module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nylob0/images/cover.jpg?1684305842562",
      "alt": "This image is the cover for the book Natchitoches Parish, Black America Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Natchitoches Parish, Black America Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From 1722 to the present, thousands of people of African descent have occupied the region that today encompasses Natchitoches Parish. For almost 300 years, African Americans have made significant contributions to the area�s economic and social"), _c('br'), _vm._v("development. In Natchitoches Parish, the lives of some of those individuals are documented as they share their views on work, religion, education, socialization, and community leadership.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rolonda D. Teal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Author Rolonda D. Teal is an anthropologist who currently resides in Sabine Parish. She received her bachelor of arts from Northwestern State University in Natchitoches and her master�s degree from the University of Houston. She has worked for several cultural organizations in Natchitoches Parish, including Cane River National Heritage Area, Cane River Creole National Historical Park, and Louisiana Regional Folklife Center. Teal is the cofounder of Cultural Lore, an anthropological and archaeological consulting agency.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ARCADIA PUBLISHING\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0